import { render, staticRenderFns } from "./SelectLocale.vue?vue&type=template&id=b5033faa&"
import script from "./SelectLocale.vue?vue&type=script&lang=js&"
export * from "./SelectLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {VBtn,VList,VListItem,VListItemTitle,VMenu})
